import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { langList } from '../../../../factories/Utils'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  createFormQuestionOption,
  deleteFormQuestionOption,
  updateFormQuestionOption,
} from '../../../../store/membership/FormQuestionOptionReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const FormQuestionOptionForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.formQuestionOption)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) => {
            const data = new FormData()

            // Iterate over languages to add localized fields in FormData
            const langCodes = langList.map((lang) => lang.code)
            for (var langCode in langCodes) {
              data.append(langCode + '[label]', values[langCode].label ?? '')
              data.append(
                langCode + '[description]',
                values[langCode].description ?? ''
              )
            }

            if (values.color) {
              data.append('color', values.color)
            }

            // Append file in FormData
            if (values.picture) {
              data.append('picture', values.picture[0].originFileObj)
            }

            return dispatch(createFormQuestionOption(data)).then(() => {
              return true
            })
          },
          update: async (values) => {
            const data = new FormData()
            data.append('id', values.id)

            // Iterate over languages to add localized fields in FormData
            const langCodes = langList.map((lang) => lang.code)
            for (var langCode in langCodes) {
              data.append(langCode + '[label]', values[langCode].label ?? '')
              data.append(
                langCode + '[description]',
                values[langCode].description ?? ''
              )
            }

            if (values.color) {
              data.append('color', values.color)
            }

            // Append file in FormData
            if (values.picture) {
              data.append('picture', values.picture[0].originFileObj)
            }

            return dispatch(updateFormQuestionOption(data)).then(() => {
              return true
            })
          },
          delete: async (values) =>
            dispatch(deleteFormQuestionOption(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

FormQuestionOptionForm.displayName = 'FormQuestionOptionForm'

export default FormQuestionOptionForm
